import { ButtonLink, PrimaryButton, SecondaryButton } from '@designsforhealth/dfh-react-components'
import styled from 'styled-components'

import Link from '../../../global/Link'

export const Container = styled.div`
  h4 {
    margin-bottom: 16px;
  }
`

export const AutoShipHR = styled.hr`
  display: none;
  @media (min-width: 600px) {
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 450px;
  }
`

export const AutoShipSeparator = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.coolGray.cool450};
`

export const AutoShipAbstract = styled.div`
  p:last-child {
    margin-bottom: 0;
  }
`

export const AutoShipIntro = styled.header`
  h3 {
    margin-bottom: 20px;
  }
  margin-bottom: 16px;
  @media (min-width: 600px) {
    margin-bottom: 0;
  }
`

export const AutoShipItemSummary = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 36px 2fr 1fr;
  font-size: 15px;
  min-height: 36px;
  line-height: 18px;
  margin-top: 14px;
  width: 100%;
`

export const AutoShipItemImage = styled.img`
  flex: 0 0 36px;
  height: 36px;
  margin-right: 10px;
`

export const AutoShipItemNameAndQty = styled.div`
  display: flex;
  flex-direction: column;
`

export const AutoShipItemName = styled.div`
  margin-right: 10px;
`

export const AutoShipItemPrice = styled.div`
  flex-grow: 0;
  margin-left: auto;
`

export const AutoShipStatusWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.grayscale.white};
  border-radius: 8px;
  margin-bottom: 16px;
  padding: 16px 19px 28px 19px;
  transition: opacity 0.15s;
  a[href] {
    &,
    &:visited {
      color: ${({ theme }) => theme.colors.component.link};
    }
  }
`

export const AutoShipRow = styled.div`
  display: grid;
  gap: 0 12px;
  grid-template-columns: 1fr;
  align-items: center;
  margin-bottom: 2px;
  @media (min-width: 600px) {
    grid-template-columns: 1fr 146px;
    padding: 12px 12px 0 12px;
  }
`

export const AutoShipTopRow = styled(AutoShipRow)`
  padding: 12px 12px 0 12px;
`
export const AutoShipMiddleRow = styled(AutoShipRow)`
  padding: 3px 12px 3px 12px;
`
export const AutoShipBottomRow = styled(AutoShipRow)`
  padding: 0 12px 12px 12px;
`
export const AutoShipItemRow = styled.div`
  margin-right: 0;
  @media (min-width: 600px) {
    margin-right: 170px;
  }
`

export const AutoShipStatusTag = styled.div<{ status: string }>`
  background: ${({ theme, status }) =>
    status === 'Suspended'
      ? theme.colors.brandYellow.light300
      : status === 'Completed'
        ? theme.colors.brandGreen.light300
        : status.includes('Payment Failed')
          ? theme.colors.brandRed.dark050
          : theme.colors.coolGray.cool150};
  border-radius: 4px;
  padding: 8px;
  width: 100%;
  height: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
  grid-column: 1;
  margin: 6px 0 6px 0;
  color: ${({ theme }) => theme.colors.component.textDark};

  @media (min-width: 600px) {
    grid-column: 2;
    margin: 0;
  }
`

export const AutoShipOrderLink = styled(Link)`
  display: flex;
  justify-content: start;
  font-weight: 400;
  text-align: right;
  text-decoration: none;

  @media (min-width: 600px) {
    justify-content: end;
  }
`

export const AutoShipOrderNumber = styled.div`
  font-weight: 500;
`

export const AutoShipItemCount = styled.div`
  grid-column: span 1;
  line-height: 18px;
  font-size: 15px;

  @media (min-width: 600px) {
    grid-column: span 2;
  }
`

export const AutoShipItemCostAndFrequency = styled.div`
  font-weight: 500;
  margin-bottom: 8px;
  line-height: 18px;
  font-size: 15px;
`

export const ShowAllButtonLink = styled(ButtonLink)`
  display: block;
  font-size: 15px;
  margin-top: 20px;
`

export const AutoShipButton = styled(SecondaryButton)`
  height: 37px;
  min-height: 37px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 146px;
  &:disabled {
    background: ${(props) => props.theme.colors.component.buttonDisabled};
    border-color: transparent; // Ensure the button's size is consistent with the active version
    color: ${(props) => props.theme.colors.grayscale.white};
  }

  margin-left: auto;
  margin-right: auto;
  @media (min-width: 600px) {
    margin-left: 0;
    margin-right: 0;
  }
`

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 32px 24px 32px;
`

export const ModalHeader = styled.div`
  background: ${({ theme }) => theme.colors.brandBlue.main};
  width: 100%;
  border-radius: 4px 4px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
`

const ModalBoldText = styled.h3`
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  font-weight: 600;
`

export const ModalTitle = styled(ModalBoldText)`
  color: ${({ theme }) => theme.colors.grayscale.white};
  font-size: 20px;
  margin: auto 0 auto 0;
`

export const ModalCloseButton = styled.button`
  height: 38px;
  width: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`

export const ModalNoButton = styled(SecondaryButton)<{
  text?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}>`
  width: 200px;
  margin: 10px 10px 0 10px;
  white-space: nowrap;
  @media (min-width: 600px) {
    width: 130px;
  }
`

export const ModalYesButton = styled(PrimaryButton)<{
  text?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}>`
  width: 200px;
  margin: 10px 10px 0 10px;
  white-space: nowrap;
  ${({ theme, text }) =>
    text === 'Yes, pause Auto-Ship' ? 'background: ' + theme.colors.brandRed.main + ';' : ''}
  border: none;
  color: ${({ theme }) => theme.colors.brand.white};
  &:hover {
    ${({ theme, text }) =>
      text === 'Yes, pause Auto-Ship' ? 'background: ' + theme.colors.brandRed.dark050 + ';' : ''}
  }
  @media (min-width: 600px) {
    width: 200px;
  }
`

export const ModalText = styled.p`
  color: ${({ theme }) => theme.colors.grayscale.black};
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  margin: 0 0 20px 0;
`

export const ModalExtraItemsText = styled(ModalText)`
  text-align: center;
`

export const ModalButtonBox = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto 0 auto;
  @media (min-width: 600px) {
    flex-direction: row;
  }
`

export const ModalItems = styled.div`
  margin: 0 0 20px 0;
`

export const AutoShipNextShipment = styled.div`
  margin-bottom: 12px;
  @media (min-width: 600px) {
    margin-bottom: 0;
  }
`

export const AutoShipAlertBox = styled.div`
  grid-column: span all;
  margin-bottom: 10px;
`

export const AutoShipAlert = styled.div<{ alertType: 'info' | 'warning' }>`
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 12px;
  margin-top: 12px;
  border-radius: 4px;
  border: 1px solid
    ${({ theme, alertType }) =>
      alertType === 'warning' ? theme.colors.brandYellow.light050 : theme.colors.blue.light500};
  background-color: ${({ theme }) => theme.colors.brand.white};

  @media (min-width: 600px) {
    grid-template-columns: 1fr 146px;
    justify-content: start;
    min-height: 61px;
  }
`

export const AutoShipAlertInfo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  margin: 6px 0 6px 0;

  @media (min-width: 600px) {
    margin: 0;
    justify-content: start;
  }
`

export const AutoShipAlertLabel = styled.div`
  font-weight: 400;
  margin-left: 10px;
  vertical-align: baseline;
`
